import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

const multiple = nota.global.multiple;

const StyledWeekSelect = styled.div`
  margin: ${multiple / 2 + "px"} 0;
  .weekSelectWrapper {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
    .weekContainer {
      .weekDay {
        cursor: pointer;
        width: ${multiple * 4 + "px"};
        height: ${multiple * 4 + "px"};
        padding: 6px;
        margin-right: 2px;
        background-color: ${nota.color.neutral.NeuFour};
        h6 {
          color: ${nota.color.neutral.NeuOne};
        }
        &:hover {
          opacity: 0.7;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
      .weekAll {
        width: 100%;
        margin-top: 2px;
        height: ${multiple * 3 + "px"};
        padding: ${multiple / 2 + "px"};
      }
      .selectedDay {
        background-color: ${nota.color.main.default};
        h6 {
          color: ${nota.color.neutral.white};
          font-weight: bold;
        }
      }
    }
  }
`;

export const weekOptions = [
  { id: 1, name: "mon" },
  { id: 2, name: "tue" },
  { id: 3, name: "wed" },
  { id: 4, name: "thu" },
  { id: 5, name: "fri" },
  { id: 6, name: "sat" },
  { id: 7, name: "sun" },
];

class WeekSelect extends BaseComponent {
  constructor(props) {
    super(props);

    let selectedIds = this.props.selectedIds ? this.props.selectedIds : [];

    this.state = {
      options: weekOptions,
      selectedIds: selectedIds,
      isAllSelected: selectedIds.length === weekOptions.length,
    };
  }

  componentDidMount() {
    /*Prevent different IsAllSelected States from Props to State */
    this.validateIsAllSelectedProp();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedIds !== this.state.selectedIds) {
      if (this.props.onChangeSelection) {
        this.props.onChangeSelection({
          selectedIds: this.state.selectedIds,
          isAllSelected: this.getIsAllSelected(),
        });
      }
    }

    if (prevProps.selectedIds !== this.props.selectedIds || this.props.forceSelection) {
      this.setState({ selectedIds: this.props.selectedIds ? this.props.selectedIds : [] });
      this.validateIsAllSelectedProp();
    }
  }

  validateIsAllSelectedProp = () => {
    if (this.props.isAllSelected === true) {
      this.setState({
        selectedIds: this.state.options.map((v) => {
          return v.id;
        }),
      });
    }
  };

  getIsAllSelected = () => {
    return this.state.selectedIds.length === this.state.options.length;
  };

  onDayClick = (v) => {
    if (this.state.selectedIds.includes(v)) {
      this.setState({
        selectedIds: this.state.selectedIds.filter((id) => {
          return id !== v;
        }),
      });
    } else {
      this.setState({ selectedIds: [...this.state.selectedIds, ...[v]] });
    }
  };

  onSelectAllClick = () => {
    if (this.getIsAllSelected()) {
      this.setState({ selectedIds: [] });
    } else {
      this.setState({
        selectedIds: this.state.options.map((v) => {
          return v.id;
        }),
      });
    }
  };

  render() {
    return (
      <StyledWeekSelect>
        <NanoFlex className="weekSelectWrapper" flexDirection="column">
          <NanoFlex className="weekContainer" justifyContent="space-between">
            {this.state.options.map((v) => {
              return (
                <NanoFlex
                  key={v.id}
                  className={`weekDay ${this.state.selectedIds.includes(v.id) ? "selectedDay" : ""}`}
                  onClick={() => {
                    this.onDayClick(v.id);
                  }}>
                  <Type.h6>{this.translation.components.weekSelect[v.name]}</Type.h6>
                </NanoFlex>
              );
            })}
          </NanoFlex>
          <NanoFlex className="weekContainer" justifyContent="space-between">
            <NanoFlex className={`weekDay weekAll ${this.getIsAllSelected() ? "selectedDay" : ""}`} onClick={this.onSelectAllClick}>
              <Type.h6>{this.translation.components.weekSelect.all}</Type.h6>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledWeekSelect>
    );
  }
}

// Set default props
WeekSelect.defaultProps = {};

export default WeekSelect;

// --- // Documentation // --- //
/*
import WeekSelect from './../Nano/WeekSelect.js';

<WeekSelect />
*/
